import React, { useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Theme from '@amzn/meridian/theme';
import AppLayout from '@amzn/meridian/app-layout';
import { Footer } from './footer';
import { AppMasthead } from './masthead';
import { ResetScroll } from './reset-scroll';
import CurrentScreen from '../routing/current-screen';
import { ThemeContext } from '../theme-context';
import { EquipmentProvider } from '../contexts/equipment-context';
import { UserProvider } from '../contexts/user-context';
import { MbmProvider } from '@amzn/react-arb-tools';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { DEFAULT_LOCALE } from '../constants';
import arbManifest from 'translations/arbManifest';
import { resolveBundleUrlWithFallbacks } from '../helpers';

const mbmOptions = {
    arbManifest,
    defaultLocalizationContext: new LocalizationContextBuilder()
        .withLocale(DEFAULT_LOCALE)
        .withDefaultLocale(DEFAULT_LOCALE)
        .build(),
    resolveBundleUrl: (
        resourcePackPath: string | undefined,
        locale: string,
        bundle: string
    ) => resolveBundleUrlWithFallbacks(resourcePackPath, locale, bundle),
};

const App = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    return (
        <MbmProvider {...mbmOptions}>
            <Theme mode={darkMode ? 'dark' : 'light'} palette="blue">
                <BrowserRouter>
                    <ResetScroll />
                    <UserProvider>
                        <EquipmentProvider>
                            <AppLayout
                                headerComponent={AppMasthead}
                                footerComponent={Footer}
                                alwaysShowScrollbar={true}
                                backgroundColor="principal"
                            >
                                <AppMasthead />
                                <Footer />
                                <CurrentScreen />
                            </AppLayout>
                        </EquipmentProvider>
                    </UserProvider>
                </BrowserRouter>
            </Theme>
        </MbmProvider>
    );
};

export default App;
